module.exports = __webpack_public_path__ + "static/intertec_screen_7-430c6d8cf162f0dc0f8efb4c64c2cb51.jpg";